<!-- Retention Workflows List Page with Splitter Layout -->
<div class="retention-workflows-list-page">
  <!-- Main Content Layout with Flex -->
  @if (!loading()) {
    <div class="main-layout">
      <!-- Sidebar Toggle (always visible) -->
      <div class="sidebar-toggle-area">
        <p-button
          [icon]="sidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
          [text]="true"
          size="small"
          (onClick)="toggleSidebar()"
          [pTooltip]="
            sidebarCollapsed() ? 'Expand filters' : 'Collapse filters'
          "
          tooltipPosition="right"
          class="sidebar-toggle-btn"
        />

        <!-- Collapsed State with Filter Button -->
        @if (sidebarCollapsed()) {
          <div class="collapsed-controls">
            <button
              class="collapsed-filter-btn"
              (click)="toggleSidebar()"
              pTooltip="Filters"
              tooltipPosition="right"
            >
              <i class="pi pi-filter"></i>
              @if (hasActiveFilters()) {
                <div class="filter-dot-indicator">
                  <i class="pi pi-circle-fill"></i>
                </div>
              }
            </button>
            <!-- Clear All Button for Collapsed State -->
            @if (hasActiveFilters()) {
              <button
                class="collapsed-clear-btn"
                (click)="clearFilters(); $event.stopPropagation()"
                pTooltip="Clear All Filters"
                tooltipPosition="right"
              >
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        }
      </div>

      <!-- Mobile Backdrop (click to close filter sidebar) -->
      <div
        class="mobile-backdrop"
        [class.visible]="!sidebarCollapsed()"
        (click)="toggleSidebar()"
      ></div>

      <!-- Filter Sidebar -->
      <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed()">
        <!-- Filter Header -->
        <div class="filters-header-main">
          <div class="header-content">
            <div class="header-left">
              <i class="pi pi-filter text-primary"></i>
              <h3 class="filters-title">Filters</h3>
            </div>
            <div class="header-right">
              <button
                class="clear-all-btn"
                [class.has-filters]="hasActiveFilters()"
                [disabled]="!hasActiveFilters()"
                (click)="clearFilters()"
              >
                Clear All
              </button>
            </div>
          </div>
        </div>

        <!-- Filter Content -->
        <div class="filters-content-scroll">
          <app-retention-workflows-filters
            [filterForm]="filterForm"
            [loading]="tableLoading()"
            (filtersChanged)="onFiltersChanged()"
          />
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="content-area" [class.sidebar-open]="!sidebarCollapsed()">
        <!-- Compact Toolbar -->
        <div
          class="content-toolbar surface-section border-bottom-1 surface-border"
        >
          <div
            class="flex align-items-center w-full gap-2"
            style="justify-content: space-between"
          >
            <div class="flex align-items-center items-center gap-2">
              <span class="text-sm text-600 font-medium">
                {{ totalRecords() }}
                {{ totalRecords() === 1 ? "Workflow" : "Workflows" }}
              </span>
              <!-- Learn More Button -->
              <p-button
                icon="pi pi-question-circle"
                [text]="true"
                size="small"
                pTooltip="Learn more"
                tooltipPosition="bottom"
                (onClick)="toggleLearnMorePopover($event)"
              />
            </div>
            <div class="flex align-items-center gap-2">
              <!-- Create New button -->
              <p-button
                label="Create"
                icon="pi pi-plus"
                size="small"
                styleClass="create-button"
                (onClick)="navigateToCreate()"
              />
            </div>
          </div>
        </div>

        <!-- Responsive Data Table Component -->
        <div class="table-container flex-1 overflow-hidden">
          <app-retention-workflows-table
            [data]="surveys()"
            [loading]="tableLoading()"
            (edit)="editSurvey($event)"
            (view)="viewSurvey($event)"
            (delete)="deleteSurvey($event)"
            (duplicate)="duplicateSurvey($event)"
            (toggleEnabled)="toggleEnabled($event)"
          />
        </div>
      </div>
    </div>
  }

  <!-- Initial Loading Skeleton -->
  @if (loading()) {
    <app-list-page-skeleton
      [sidebarCollapsed]="sidebarCollapsed()"
      filterPreset="retentionWorkflows"
      tablePreset="retentionWorkflows"
    />
  }
</div>

<!-- Learn More Popover -->
<p-popover #learnMorePopover [style]="{ width: '320px' }">
  <div class="popover-content learn-more-popover">
    <div class="popover-sticky-header">
      <h4>{{ learnMoreContent.title }}</h4>
      <button
        type="button"
        class="popover-close"
        (click)="learnMorePopover.hide()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="popover-body">
      <p>{{ learnMoreContent.description }}</p>
      <p-button
        [label]="learnMoreContent.learnMoreLabel"
        severity="primary"
        size="small"
        (onClick)="openDocs()"
      />
    </div>
  </div>
</p-popover>

<!-- Toast Messages -->
<p-toast
  position="top-right"
  [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
/>

<!-- Confirmation Dialog -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
/>
